import { render, staticRenderFns } from "./EditarMeioRecebimento.vue?vue&type=template&id=dcd1a810&"
import script from "./EditarMeioRecebimento.vue?vue&type=script&lang=js&"
export * from "./EditarMeioRecebimento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports